(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oui-madame-lp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pbOuiMadameCopy) return;
    window.__pbOuiMadameCopy = true;

    function fallbackCopy(text) {
      // In-app browsers (Instagram, Facebook) can block navigator.clipboard.
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      area.remove();
      return ok;
    }

    function done(button, ok) {
      var label = button.querySelector('[data-om-copy-label]');
      var live = button.closest('.om')?.querySelector('[data-om-live]');
      if (!label) return;
      if (!button.dataset.omDefault) button.dataset.omDefault = label.textContent;
      label.textContent = ok ? button.dataset.omCopied : button.dataset.omDefault;
      if (live) live.textContent = ok ? button.dataset.omCopied : '';
      clearTimeout(button._omTimer);
      button._omTimer = setTimeout(function () {
        label.textContent = button.dataset.omDefault;
      }, 3000);
    }

    document.addEventListener('click', function (event) {
      // A tap on the text box copies too; feedback still shows on the card's button.
      var box = event.target.closest('[data-om-copy-box]');
      var button = box ? box.parentElement.querySelector('[data-om-copy]') : event.target.closest('[data-om-copy]');
      if (!button) return;
      var text = button.dataset.omCopy;
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text).then(
          function () {
            done(button, true);
          },
          function () {
            done(button, fallbackCopy(text));
          }
        );
      } else {
        done(button, fallbackCopy(text));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-actions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE_MQ = '(max-width: 991px)';
    const GUTTER_MOBILE = 20;
    const SPACE_BETWEEN = 16;

    const initCompareSliders = (root = document) => {
      const compares = root.querySelectorAll('[data-pb-lip-compare]');

      for (const compare of compares) {
        if (compare.dataset.pbLipCompareReady === 'true') continue;

        const clip = compare.querySelector('[data-pb-lip-compare-clip]');
        const handle = compare.querySelector('[data-pb-lip-compare-handle]');

        if (!clip || !handle) continue;

        compare.dataset.pbLipCompareReady = 'true';

        let dragging = false;
        let pos = 50;

        const setPos = (pct) => {
          pos = Math.max(0, Math.min(100, pct));
          clip.style.clipPath = `inset(0 0 0 ${pos}%)`;
          handle.style.left = `${pos}%`;
          handle.setAttribute('aria-valuenow', String(Math.round(pos)));
        };

        const getPct = (event) => {
          const rect = compare.getBoundingClientRect();
          const point = event.touches ? event.touches[0] : event;
          return ((point.clientX - rect.left) / rect.width) * 100;
        };

        const startDrag = (event) => {
          dragging = true;
          compare.classList.add('is-dragging');
          setPos(getPct(event));
        };

        const moveDrag = (event) => {
          if (!dragging) return;
          if (event.cancelable) event.preventDefault();
          setPos(getPct(event));
        };

        const endDrag = () => {
          dragging = false;
          compare.classList.remove('is-dragging');
        };

        compare.addEventListener('mousedown', startDrag);
        compare.addEventListener('touchstart', startDrag, { passive: true });
        window.addEventListener('mousemove', moveDrag);
        window.addEventListener('touchmove', moveDrag, { passive: false });
        window.addEventListener('mouseup', endDrag);
        window.addEventListener('touchend', endDrag);

        handle.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setPos(pos - 2);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            setPos(pos + 2);
          } else if (event.key === 'Home') {
            event.preventDefault();
            setPos(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            setPos(100);
          }
        });
      }
    };

    const waitForSwiper = () =>
      new Promise((resolve) => {
        if (typeof Swiper !== 'undefined') {
          resolve();
          return;
        }

        let tries = 0;
        const timer = setInterval(() => {
          tries += 1;
          if (typeof Swiper !== 'undefined' || tries > 80) {
            clearInterval(timer);
            resolve();
          }
        }, 50);
      });

    const swiperByEl = new WeakMap();

    const destroyActionsSwiper = (el) => {
      const instance = swiperByEl.get(el);
      if (!instance) return;
      instance.destroy(true, true);
      swiperByEl.delete(el);
    };

    const initActionsSwiper = (el) => {
      if (!el || typeof Swiper === 'undefined') return;
      if (swiperByEl.get(el)) return;
      if (!el.querySelectorAll('.swiper-slide').length) return;

      const instance = new Swiper(el, {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: SPACE_BETWEEN,
        slidesOffsetBefore: GUTTER_MOBILE,
        slidesOffsetAfter: GUTTER_MOBILE,
        watchOverflow: true,
        resistanceRatio: 0.65,
        speed: 400,
        noSwipingClass: 'swiper-no-swiping',
      });

      swiperByEl.set(el, instance);
    };

    const syncActionsSwipers = () => {
      const isMobile = window.matchMedia(MOBILE_MQ).matches;
      const els = document.querySelectorAll('[data-pb-lip-actions-swiper]');

      for (const el of els) {
        if (isMobile) {
          initActionsSwiper(el);
        } else {
          destroyActionsSwiper(el);
        }
      }
    };

    const boot = async () => {
      initCompareSliders();
      await waitForSwiper();
      syncActionsSwipers();

      const mq = window.matchMedia(MOBILE_MQ);
      const onChange = () => syncActionsSwipers();

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onChange);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(onChange);
      }

      document.addEventListener('shopify:section:load', async (event) => {
        const root = event.target;
        initCompareSliders(root);
        await waitForSwiper();
        syncActionsSwipers();
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const el = event.target.querySelector?.('[data-pb-lip-actions-swiper]');
        if (el) destroyActionsSwiper(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-body-scan"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-pb-lip-bodyscan]';
    const booted = new WeakSet();

    const initSection = (root) => {
      if (!root || booted.has(root)) return;
      booted.add(root);

      const states = Array.from(root.querySelectorAll('[data-pb-lip-bodyscan-state]'));
      const hotspots = Array.from(root.querySelectorAll('[data-pb-lip-bodyscan-hotspot]'));
      const wrapper = root.querySelector('[data-pb-lip-bodyscan-states]');
      const panel = root.querySelector('[data-pb-lip-bodyscan-panel]');
      const prev = root.querySelector('[data-pb-lip-bodyscan-prev]');
      const next = root.querySelector('[data-pb-lip-bodyscan-next]');
      if (!states.length || !wrapper) return;

      let active = 0;
      let heightTimer = 0;

      // Animate between two content heights, then hand control back to the
      // content so the panel keeps reflowing with the viewport. The target is
      // measured on the active state itself — the hidden ones are still in the
      // box and would otherwise report the tallest of them all.
      const animateHeight = (from) => {
        const activeState = states.find((state) => Number(state.dataset.index) === active);
        const to = activeState ? activeState.offsetHeight : 0;
        if (!to || from === to) return;

        if (heightTimer) {
          window.clearTimeout(heightTimer);
          heightTimer = 0;
        }

        wrapper.style.height = from + 'px';
        void wrapper.offsetHeight;
        wrapper.style.height = to + 'px';
        heightTimer = window.setTimeout(() => {
          heightTimer = 0;
          if (wrapper.style.height === to + 'px') wrapper.style.height = '';
        }, 420);
      };

      const render = (previousHeight) => {
        states.forEach((state) => {
          const isActive = Number(state.dataset.index) === active;
          state.classList.toggle('is-active', isActive);
          state.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          state.querySelectorAll('a, button').forEach((el) => {
            if (isActive) {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', '-1');
            }
          });
        });

        hotspots.forEach((hotspot) => {
          hotspot.setAttribute('aria-pressed', Number(hotspot.dataset.target) === active ? 'true' : 'false');
        });

        if (panel) {
          panel.style.setProperty(
            '--pb-lip-bodyscan-panel',
            active === 0 ? 'var(--pb-lip-bodyscan-panel-intro)' : 'var(--pb-lip-bodyscan-panel-detail)',
          );
        }

        // There is nothing before the intro, so the back arrow starts hidden.
        if (prev) prev.hidden = active === 0;

        if (typeof previousHeight === 'number') animateHeight(previousHeight);
      };

      const goTo = (index, { revealPanel = false } = {}) => {
        const count = states.length;
        const from = wrapper.offsetHeight;
        active = ((index % count) + count) % count;
        render(from);

        if (!revealPanel || !panel || window.matchMedia('(min-width: 992px)').matches) return;

        const activeState = states.find((state) => Number(state.dataset.index) === active);
        const to = activeState ? activeState.offsetHeight : 0;
        // Wait for the panel height transition so the full answer block is measured.
        const delay = to && from !== to ? 430 : 0;

        window.setTimeout(() => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          panel.scrollIntoView({
            behavior: reduced ? 'auto' : 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }, delay);
      };

      for (const hotspot of hotspots) {
        hotspot.addEventListener('click', () => {
          goTo(Number(hotspot.dataset.target), { revealPanel: true });
        });
      }

      if (prev) prev.addEventListener('click', () => goTo(active - 1));
      if (next) next.addEventListener('click', () => goTo(active + 1));

      root.pbLipBodyScanGoTo = goTo;
      render();
    };

    const initAll = (scope) => {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initSection(container);
      container.querySelectorAll?.(SELECTOR).forEach(initSection);
    };

    const boot = () => {
      initAll(document);

      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const root = event.target.closest?.(SELECTOR);
        if (!root || typeof root.pbLipBodyScanGoTo !== 'function') return;
        const hotspot = event.target.closest?.('[data-pb-lip-bodyscan-hotspot]');
        root.pbLipBodyScanGoTo(hotspot ? Number(hotspot.dataset.target) : 0);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const supportsNative =
      typeof CSS !== 'undefined' &&
      typeof CSS.supports === 'function' &&
      CSS.supports('selector(::details-content)');

    const reducedMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getDurationMs = (section) => {
      if (reducedMotion()) return 0;
      const raw = getComputedStyle(section).getPropertyValue('--pb-lip-faq-accordion-duration').trim();
      const seconds = Number.parseFloat(raw);
      if (Number.isFinite(seconds)) return Math.round(seconds * 1000);
      return 350;
    };

    const animatePanel = (panel, from, to, duration) =>
      new Promise((resolve) => {
        if (duration <= 0) {
          panel.style.height = to === 'auto' ? '' : `${to}px`;
          panel.style.opacity = to === 0 ? '0' : '1';
          resolve();
          return;
        }

        panel.style.height = typeof from === 'number' ? `${from}px` : from;
        panel.style.opacity = from === 0 ? '0' : '1';
        // Force reflow before transitioning
        panel.getBoundingClientRect();
        panel.style.height = typeof to === 'number' ? `${to}px` : to;
        panel.style.opacity = to === 0 ? '0' : '1';

        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          panel.removeEventListener('transitionend', onEnd);
          resolve();
        };
        const onEnd = (event) => {
          if (event.target === panel && event.propertyName === 'height') finish();
        };
        panel.addEventListener('transitionend', onEnd);
        window.setTimeout(finish, duration + 50);
      });

    const bindItem = (section, details) => {
      if (details.dataset.pbLipFaqBound === 'true') return;
      details.dataset.pbLipFaqBound = 'true';

      const summary = details.querySelector('.pb-lip-faq__summary');
      const panel = details.querySelector('.pb-lip-faq__panel');
      if (!summary || !panel) return;

      summary.addEventListener('click', async (event) => {
        event.preventDefault();
        if (details.dataset.pbLipFaqBusy === 'true') return;
        details.dataset.pbLipFaqBusy = 'true';

        const duration = getDurationMs(section);

        if (details.open) {
          const startHeight = panel.scrollHeight;
          await animatePanel(panel, startHeight, 0, duration);
          details.removeAttribute('open');
          panel.style.height = '';
          panel.style.opacity = '';
        } else {
          details.setAttribute('open', '');
          const endHeight = panel.scrollHeight;
          await animatePanel(panel, 0, endHeight, duration);
          panel.style.height = '';
          panel.style.opacity = '';
        }

        details.dataset.pbLipFaqBusy = 'false';
      });
    };

    const initSection = (section) => {
      if (!section || section.dataset.pbLipFaqInit === 'true') return;
      section.dataset.pbLipFaqInit = 'true';

      if (supportsNative) return;

      section.classList.add('pb-lip-faq--js-animate');
      const items = section.querySelectorAll('.pb-lip-faq__item');
      for (const item of items) bindItem(section, item);
    };

    const boot = () => {
      const sections = document.querySelectorAll('.pb-lip-faq');
      for (const section of sections) initSection(section);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector?.('.pb-lip-faq') || event.target.closest?.('.pb-lip-faq');
      if (section) {
        delete section.dataset.pbLipFaqInit;
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-pb-lip-footer-newsletter]';

    const showError = (errorEl, message) => {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = message || 'Something went wrong.';
    };

    const clearError = (errorEl) => {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    };

    const initNewsletter = (root) => {
      if (!root || root.dataset.pbLipFooterInit === 'true') return;
      root.dataset.pbLipFooterInit = 'true';

      const form = root.querySelector('.pb-lip-footer__form');
      if (!form) return;

      const iframeName = root.dataset.iframeName;
      if (iframeName) form.setAttribute('target', iframeName);

      const iframe = iframeName
        ? root.querySelector(`iframe[name="${iframeName}"]`)
        : null;
      const title = root.querySelector('[data-pb-lip-footer-title]');
      const tags = form.querySelector('[data-pb-lip-footer-tags]');
      const step1 = form.querySelector('[data-pb-lip-footer-step="1"]');
      const step2 = form.querySelector('[data-pb-lip-footer-step="2"]');
      const btnNext = form.querySelector('[data-pb-lip-footer-next]');
      const btnSubmit = form.querySelector('[data-pb-lip-footer-submit]');
      const emailEl = form.querySelector('[data-pb-lip-footer-email]');
      const phoneEl = form.querySelector('[data-pb-lip-footer-phone]');
      const countryEl = form.querySelector('[data-pb-lip-footer-country]');
      const errorEl = form.querySelector('[data-pb-lip-footer-error]');
      const hiddenPhone = form.querySelector('[data-pb-lip-footer-hidden-phone]');
      const hiddenCountry = form.querySelector('[data-pb-lip-footer-hidden-country]');
      const hiddenWa = form.querySelector('[data-pb-lip-footer-hidden-wa]');
      const waSuccessTitle = root.dataset.waSuccessTitle || '';
      let submitted = false;

      const showStep2 = () => {
        if (step1) step1.hidden = true;
        if (step2) step2.hidden = false;
        if (title && waSuccessTitle) title.textContent = waSuccessTitle;
        if (tags) tags.value = 'newsletter,consent_whatsapp';
        window.setTimeout(() => {
          if (phoneEl) phoneEl.focus();
        }, 0);
      };

      if (iframe) {
        iframe.addEventListener('load', () => {
          if (!submitted) return;

          try {
            const doc = iframe.contentDocument || iframe.contentWindow.document;
            const pageTitle = doc && doc.title ? doc.title : '';
            const bodyText = doc && doc.body ? doc.body.innerText || '' : '';
            const haystack = `${pageTitle} ${bodyText}`.toLowerCase();

            if (haystack.includes('captcha')) {
              showError(errorEl, 'Captcha blocked the submission. Try again.');
              if (btnSubmit) btnSubmit.disabled = false;
              return;
            }

            if (haystack.includes('error') || haystack.includes('failed')) {
              showError(errorEl, 'Submission failed. Please try again.');
              if (btnSubmit) btnSubmit.disabled = false;
              return;
            }

            if (emailEl) emailEl.readOnly = true;
            if (phoneEl) phoneEl.readOnly = true;
            showError(errorEl, '✅ Saved! Thanks.');
          } catch (_error) {
            showError(errorEl, '✅ Saved! Thanks.');
          }
        });
      }

      if (btnNext) {
        btnNext.addEventListener('click', () => {
          clearError(errorEl);
          const emailVal = (emailEl && emailEl.value ? emailEl.value : '').trim();
          if (!emailVal) {
            showError(errorEl, 'Please enter your email.');
            return;
          }
          if (emailEl && emailEl.checkValidity && !emailEl.checkValidity()) {
            showError(errorEl, 'Please enter a valid email.');
            return;
          }
          showStep2();
        });
      }

      if (btnSubmit) {
        btnSubmit.addEventListener('click', () => {
          clearError(errorEl);

          const emailVal = (emailEl && emailEl.value ? emailEl.value : '').trim();
          if (!emailVal) {
            showError(errorEl, 'Please enter your email.');
            return;
          }
          if (emailEl && emailEl.checkValidity && !emailEl.checkValidity()) {
            showError(errorEl, 'Please enter a valid email.');
            return;
          }

          const phoneVal = (phoneEl && phoneEl.value ? phoneEl.value : '').trim();
          if (!phoneVal) {
            showError(errorEl, 'Please enter your WhatsApp number.');
            return;
          }

          const country = countryEl && countryEl.value ? countryEl.value : '';
          const fullPhone = `${country} ${phoneVal}`.trim();
          if (hiddenPhone) hiddenPhone.value = fullPhone;
          if (hiddenCountry) hiddenCountry.value = country;
          if (hiddenWa) hiddenWa.value = fullPhone;

          submitted = true;
          btnSubmit.disabled = true;
          form.submit();
        });
      }

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    };

    const boot = () => {
      const roots = document.querySelectorAll(SELECTOR);
      for (const root of roots) initNewsletter(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root =
        event.target.querySelector?.(SELECTOR) || event.target.closest?.(SELECTOR);
      if (root) {
        delete root.dataset.pbLipFooterInit;
        initNewsletter(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-pb-lip-header]');
    if (!root) return;

    const section = root.closest('.shopify-section') || root;
    const toggleBtn = root.querySelector('[data-pb-lip-menu-toggle]');
    const drawer = root.querySelector('[data-pb-lip-drawer]');
    const bar = root.querySelector('.pb-lip-header__bar');
    const closeBtns = root.querySelectorAll('[data-pb-lip-menu-close]');

    if (!toggleBtn || !drawer || !bar) return;

    let scrollLockY = 0;
    let spacer = null;

    const syncHeaderHeight = () => {
      root.style.setProperty('--pb-lip-header-h', `${Math.round(bar.getBoundingClientRect().height)}px`);
    };

    const lockScroll = () => {
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      const sectionHeight = Math.round(section.getBoundingClientRect().height);

      if (!spacer) {
        spacer = document.createElement('div');
        spacer.setAttribute('data-pb-lip-header-spacer', '');
        spacer.setAttribute('aria-hidden', 'true');
        section.insertAdjacentElement('afterend', spacer);
      }

      spacer.style.height = `${sectionHeight}px`;
      document.documentElement.classList.add('pb-lip-menu-open');
      document.body.style.top = `-${scrollLockY}px`;
      section.classList.add('pb-lip-header-section--menu-open');
    };

    const unlockScroll = () => {
      const y = scrollLockY;

      section.classList.remove('pb-lip-header-section--menu-open');

      if (spacer) {
        spacer.remove();
        spacer = null;
      }

      document.documentElement.classList.remove('pb-lip-menu-open');
      document.body.style.top = '';

      /* Restore instantly — avoid smooth scroll animating from top → y */
      const html = document.documentElement;
      const previousBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';

      if (typeof window.scrollTo === 'function') {
        try {
          window.scrollTo({ top: y, left: 0, behavior: 'instant' });
        } catch (error) {
          window.scrollTo(0, y);
        }
      }

      html.scrollTop = y;
      document.body.scrollTop = y;
      html.style.scrollBehavior = previousBehavior;
    };

    const setOpen = (open) => {
      syncHeaderHeight();

      if (open) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        toggleBtn.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelClose || 'Close menu');
        lockScroll();
      } else {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggleBtn.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.setAttribute('aria-label', toggleBtn.dataset.labelOpen || 'Open menu');
        unlockScroll();
      }
    };

    toggleBtn.addEventListener('click', () => {
      setOpen(!drawer.classList.contains('is-open'));
    });

    for (const btn of closeBtns) {
      btn.addEventListener('click', () => setOpen(false));
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        setOpen(false);
      }
    });

    const mq = window.matchMedia('(min-width: 992px)');
    const onMq = () => {
      if (mq.matches) setOpen(false);
    };
    mq.addEventListener('change', onMq);

    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-pb-lip-quiz]';
    const VISIBLE_BEHIND = 2;
    const booted = new WeakSet();

    const formatNumber = (value, useThousands) => {
      if (!useThousands) return String(value);
      const [whole, fraction] = String(value).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return fraction ? `${grouped},${fraction}` : grouped;
    };

    const readLabels = (root) => {
      const node = root.querySelector('[data-pb-lip-quiz-labels]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent) || {};
      } catch (error) {
        return {};
      }
    };

    const fill = (template, values) =>
      String(template || '').replace(/\{(\w+)\}/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match,
      );

    const initQuiz = (root) => {
      if (!root || booted.has(root)) return;
      booted.add(root);

      const cards = Array.from(root.querySelectorAll('[data-pb-lip-quiz-card]'));
      if (!cards.length) return;

      const labels = readLabels(root);
      const questionCards = cards.filter((card) => card.dataset.mode !== 'outro');
      const total = questionCards.length;
      const tolerance = Number(root.dataset.tolerance || 0);
      const currentEl = root.querySelector('[data-pb-lip-quiz-current]');
      const dots = Array.from(root.querySelectorAll('[data-pb-lip-quiz-dot]'));
      const skipButton = root.querySelector('[data-pb-lip-quiz-skip]');
      const pill = root.querySelector('[data-pb-lip-quiz-pill]');
      const scoreEl = root.querySelector('[data-pb-lip-quiz-score]');
      const baseBg = getComputedStyle(root).getPropertyValue('--pb-lip-quiz-bg-base').trim();
      const hasWave = root.classList.contains('pb-lip-quiz--has-wave');

      let active = 0;
      let score = 0;
      let revealTimer = 0;

      const clearRevealTimer = () => {
        if (!revealTimer) return;
        window.clearTimeout(revealTimer);
        revealTimer = 0;
      };

      // Only the face that is currently turned towards the visitor should be
      // reachable — the other one keeps rendering behind it.
      const syncFocus = (card) => {
        const isActive = Number(card.dataset.index) === active;
        const flipped = card.dataset.flipped === 'true';

        card.querySelectorAll('.pb-lip-quiz__face').forEach((face) => {
          const isBack = face.classList.contains('pb-lip-quiz__face--back');
          const reachable = isActive && isBack === flipped;

          face.setAttribute('aria-hidden', reachable ? 'false' : 'true');
          face.querySelectorAll('button, a, input').forEach((el) => {
            if (reachable) {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', '-1');
            }
          });
        });
      };

      const render = () => {
        cards.forEach((card) => {
          const pos = Number(card.dataset.index) - active;
          let state = 'hidden';

          if (pos < 0) {
            state = 'done';
          } else if (pos === 0) {
            state = 'active';
          } else if (pos <= VISIBLE_BEHIND) {
            state = 'behind';
          }

          card.dataset.state = state;
          card.dataset.stack = String(Math.max(pos, 0));
          card.style.setProperty('--pb-lip-quiz-pos', String(Math.max(pos, 0)));
          // A card that just left stays on top while it animates away.
          card.style.zIndex = String(pos < 0 ? cards.length + 1 : cards.length - pos);

          syncFocus(card);
        });

        const activeCard = cards.find((card) => Number(card.dataset.index) === active);
        /* With a wave image, keep the light base so transparent edges stay correct.
           Per-card bg swaps would paint a solid block over the wave. */
        if (!hasWave) {
          const nextBg = (activeCard && activeCard.dataset.bg) || baseBg;
          if (nextBg) root.style.setProperty('--pb-lip-quiz-bg', nextBg);
        }

        if (currentEl) currentEl.textContent = String(Math.min(active + 1, total));

        dots.forEach((dot) => {
          const index = Number(dot.dataset.index);
          if (index < active) {
            dot.dataset.state = 'done';
          } else if (index === active) {
            dot.dataset.state = 'current';
          } else {
            dot.dataset.state = 'upcoming';
          }
        });

        const finished = active >= total;
        if (pill) pill.hidden = finished;
        if (skipButton) skipButton.hidden = finished;

        if (finished && scoreEl && labels.score) {
          scoreEl.textContent = fill(labels.score, { score: String(score), total: String(total) });
        }
      };

      const goTo = (index) => {
        clearRevealTimer();
        active = Math.max(0, Math.min(index, cards.length - 1));
        render();
      };

      const reveal = (card, verdict, isCorrect) => {
        // Ignore stale delayed reveals after skip / next / restart.
        if (card.dataset.flipped === 'true') return;
        if (Number(card.dataset.index) !== active) return;

        const verdictEl = card.querySelector('[data-pb-lip-quiz-verdict]');
        if (verdictEl) verdictEl.textContent = verdict;
        card.dataset.flipped = 'true';
        card.dataset.wasCorrect = isCorrect ? 'true' : 'false';
        if (isCorrect) score += 1;
        syncFocus(card);
      };

      const unflip = (card) => {
        if (card.dataset.flipped !== 'true') return;
        if (card.dataset.wasCorrect === 'true') score = Math.max(0, score - 1);
        card.dataset.flipped = 'false';
        card.dataset.wasCorrect = 'false';
        const verdictEl = card.querySelector('[data-pb-lip-quiz-verdict]');
        if (verdictEl) verdictEl.textContent = '';
        syncFocus(card);
      };

      const resetChoiceOptions = (card) => {
        card.querySelectorAll('[data-pb-lip-quiz-option]').forEach((option) => {
          option.setAttribute('aria-selected', 'false');
        });
      };

      const resetSlider = (card) => {
        const range = card.querySelector('[data-pb-lip-quiz-range]');
        if (!range) return;
        range.value = range.defaultValue;
        range.dispatchEvent(new Event('input', { bubbles: true }));
      };

      questionCards.forEach((card) => {
        const isChoice = card.dataset.mode === 'choice';

        if (isChoice) {
          const options = Array.from(card.querySelectorAll('[data-pb-lip-quiz-option]'));
          const correctOption = card.dataset.correctOption;

          options.forEach((option) => {
            option.setAttribute('aria-selected', 'false');
            option.addEventListener('click', () => {
              if (card.dataset.flipped === 'true') return;
              if (Number(card.dataset.index) !== active) return;

              options.forEach((other) => other.setAttribute('aria-selected', 'false'));
              option.setAttribute('aria-selected', 'true');

              const isCorrect = option.dataset.option === correctOption;
              const guess = option.dataset.label || '';
              const template = isCorrect ? labels.correct : labels.wrong;

              clearRevealTimer();
              revealTimer = window.setTimeout(() => {
                revealTimer = 0;
                reveal(card, fill(template, { guess }), isCorrect);
              }, 320);
            });
          });
        } else {
          const range = card.querySelector('[data-pb-lip-quiz-range]');
          const valueEl = card.querySelector('[data-pb-lip-quiz-value]');
          const flipButton = card.querySelector('[data-pb-lip-quiz-flip]');
          const useThousands = card.dataset.thousands === 'true';
          const min = Number(card.dataset.min || 0);
          const max = Number(card.dataset.max || 100);
          const correct = Number(card.dataset.correct || 0);
          const unit = card.dataset.unit || '';

          const syncRange = () => {
            if (!range) return;
            const value = Number(range.value);
            const span = max - min || 1;
            const percent = ((value - min) / span) * 100;
            range.style.setProperty('--pb-lip-quiz-fill', `${percent}%`);
            if (valueEl) valueEl.textContent = formatNumber(value, useThousands);
          };

          if (range) {
            range.addEventListener('input', syncRange);
            syncRange();
          }

          if (flipButton) {
            flipButton.addEventListener('click', () => {
              const value = range ? Number(range.value) : 0;
              const span = max - min || 1;
              const delta = value - correct;
              const withinTolerance = Math.abs(delta) <= (span * tolerance) / 100;
              // "30%" but "10.000 partikels" — only word units get a space.
              const separator = /^[\p{L}]/u.test(unit) ? ' ' : '';
              const guess = `${formatNumber(value, useThousands)}${unit ? separator + unit : ''}`;

              let template = labels.close;
              if (delta === 0) {
                template = labels.exact || labels.close;
              } else if (!withinTolerance) {
                template = delta < 0 ? labels.under : labels.over;
              }

              reveal(card, fill(template, { guess }), withinTolerance);
            });
          }
        }

        const resetButton = card.querySelector('[data-pb-lip-quiz-reset]');
        if (resetButton) {
          resetButton.addEventListener('click', () => {
            clearRevealTimer();
            unflip(card);
            resetChoiceOptions(card);
          });
        }

        const nextButton = card.querySelector('[data-pb-lip-quiz-next]');
        if (nextButton) {
          nextButton.addEventListener('click', () => goTo(Number(card.dataset.index) + 1));
        }
      });

      if (skipButton) {
        skipButton.addEventListener('click', () => goTo(cards.length - 1));
      }

      const restartButton = root.querySelector('[data-pb-lip-quiz-restart]');
      if (restartButton) {
        restartButton.addEventListener('click', () => {
          clearRevealTimer();
          score = 0;
          if (scoreEl) scoreEl.textContent = '';
          questionCards.forEach((card) => {
            card.dataset.flipped = 'false';
            card.dataset.wasCorrect = 'false';
            const verdictEl = card.querySelector('[data-pb-lip-quiz-verdict]');
            if (verdictEl) verdictEl.textContent = '';
            resetChoiceOptions(card);
            resetSlider(card);
          });
          goTo(0);
        });
      }

      root.pbLipQuizGoTo = goTo;
      render();
    };

    const initAll = (scope) => {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initQuiz(container);
      container.querySelectorAll?.(SELECTOR).forEach(initQuiz);
    };

    const boot = () => {
      initAll(document);

      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest?.('[data-pb-lip-quiz-card]');
        const root = event.target.closest?.(SELECTOR);
        if (card && root && typeof root.pbLipQuizGoTo === 'function') {
          root.pbLipQuizGoTo(Number(card.dataset.index));
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-rooms"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const BREAKPOINT = 992;
    const SELECTOR = '[data-pb-lip-rooms]';

    const getParts = (item) => ({
      top: item.querySelector('[data-pb-lip-rooms-top]'),
      bottom: item.querySelector('[data-pb-lip-rooms-bottom]'),
      toggle: item.querySelector('[data-pb-lip-rooms-toggle]'),
    });

    const setClosedHeight = (item, top) => {
      item.style.height = `${top.offsetHeight}px`;
    };

    const openItem = (item, top, bottom, toggle) => {
      item.style.height = `${top.offsetHeight + bottom.offsetHeight}px`;
      item.classList.add('is-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', toggle.dataset.closeLabel || 'Hide content');
      }
    };

    const closeItem = (item, top, toggle) => {
      item.style.height = `${top.offsetHeight}px`;
      item.classList.remove('is-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', toggle.dataset.openLabel || 'Show content');
      }
    };

    const bindItem = (section, item) => {
      if (item.dataset.pbLipRoomsBound === 'true') return;
      item.dataset.pbLipRoomsBound = 'true';

      const { top, bottom, toggle } = getParts(item);
      if (!top || !bottom) return;

      setClosedHeight(item, top);

      item.addEventListener('mouseenter', () => {
        if (window.innerWidth < BREAKPOINT) return;
        openItem(item, top, bottom, toggle);
      });

      item.addEventListener('mouseleave', () => {
        if (window.innerWidth < BREAKPOINT) return;
        closeItem(item, top, toggle);
      });

      item.addEventListener('focusin', () => {
        if (window.innerWidth < BREAKPOINT) return;
        openItem(item, top, bottom, toggle);
      });

      item.addEventListener('focusout', (event) => {
        if (window.innerWidth < BREAKPOINT) return;
        if (item.contains(event.relatedTarget)) return;
        closeItem(item, top, toggle);
      });

      item.addEventListener('click', (event) => {
        if (window.innerWidth >= BREAKPOINT) return;
        if (event.target.closest('a, button')) return;
        if (item.classList.contains('is-open')) {
          closeItem(item, top, toggle);
        } else {
          openItem(item, top, bottom, toggle);
        }
      });

      if (toggle) {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (item.classList.contains('is-open')) {
            closeItem(item, top, toggle);
          } else {
            openItem(item, top, bottom, toggle);
          }
        });
      }
    };

    const resetHeights = (section) => {
      const items = section.querySelectorAll('[data-pb-lip-rooms-item]');
      for (const item of items) {
        const { top, bottom, toggle } = getParts(item);
        if (!top || !bottom) continue;
        if (item.classList.contains('is-open')) {
          openItem(item, top, bottom, toggle);
        } else {
          closeItem(item, top, toggle);
        }
      }
    };

    const initSection = (section) => {
      if (!section) return;
      const items = section.querySelectorAll('[data-pb-lip-rooms-item]');
      for (const item of items) bindItem(section, item);
      resetHeights(section);
    };

    const boot = () => {
      const sections = document.querySelectorAll(SELECTOR);
      for (const section of sections) initSection(section);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    let resizeTimer = 0;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        const sections = document.querySelectorAll(SELECTOR);
        for (const section of sections) resetHeights(section);
      }, 100);
    });

    document.addEventListener('shopify:section:load', (event) => {
      const section =
        event.target.querySelector?.(SELECTOR) || event.target.closest?.(SELECTOR);
      if (section) {
        const items = section.querySelectorAll('[data-pb-lip-rooms-item]');
        for (const item of items) delete item.dataset.pbLipRoomsBound;
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-lip-routine-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-pb-lip-routine]';
    const booted = new WeakSet();

    const initSection = (root) => {
      if (!root || booted.has(root)) return;
      booted.add(root);

      root.querySelectorAll('[data-pb-lip-routine-flip]').forEach((flipper) => {
        const front = flipper.querySelector('[data-pb-lip-routine-face="front"]');
        const back = flipper.querySelector('[data-pb-lip-routine-face="back"]');

        flipper.addEventListener('click', () => {
          const flipped = flipper.getAttribute('aria-pressed') === 'true';
          const next = !flipped;
          flipper.setAttribute('aria-pressed', next ? 'true' : 'false');
          if (front) front.setAttribute('aria-hidden', next ? 'true' : 'false');
          if (back) back.setAttribute('aria-hidden', next ? 'false' : 'true');
        });
      });

      const viewport = root.querySelector('[data-pb-lip-routine-viewport]');
      const pages = Array.from(root.querySelectorAll('[data-pb-lip-routine-page]'));
      const dots = Array.from(root.querySelectorAll('[data-pb-lip-routine-dot]'));
      if (!viewport || pages.length < 2 || dots.length < 2) return;

      const setActive = (index) => {
        const safeIndex = Number.isFinite(index) ? Math.max(0, Math.min(index, pages.length - 1)) : 0;
        dots.forEach((dot) => {
          dot.setAttribute('aria-current', Number(dot.dataset.page) === safeIndex ? 'true' : 'false');
        });
      };

      // Measured off the pages themselves — the viewport's own width does not
      // account for the page padding, so it drifts out of step on long lists.
      const pageOffset = (index) => {
        const page = pages[index];
        if (!page) return 0;
        return page.offsetLeft - pages[0].offsetLeft;
      };

      const currentPage = () => {
        const target = viewport.scrollLeft;
        let closest = 0;
        pages.forEach((page, index) => {
          if (Math.abs(pageOffset(index) - target) < Math.abs(pageOffset(closest) - target)) {
            closest = index;
          }
        });
        return closest;
      };

      const goTo = (index) => {
        const safeIndex = Number.isFinite(index) ? Math.max(0, Math.min(index, pages.length - 1)) : 0;
        viewport.scrollTo({ left: pageOffset(safeIndex), behavior: 'smooth' });
        setActive(safeIndex);
      };

      let frame = 0;
      viewport.addEventListener(
        'scroll',
        () => {
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = 0;
            setActive(currentPage());
          });
        },
        { passive: true },
      );

      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(Number(dot.dataset.page)));
      });

      // Bring the page holding a block into view when it is selected in the editor.
      root.pbLipRoutineShow = (card) => {
        const page = card.closest('[data-pb-lip-routine-page]');
        if (page) goTo(Number(page.dataset.page));
      };
    };

    const initAll = (scope) => {
      const container = scope || document;
      if (container.matches && container.matches(SELECTOR)) initSection(container);
      container.querySelectorAll?.(SELECTOR).forEach(initSection);
    };

    const boot = () => {
      initAll(document);

      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest?.('[data-pb-lip-routine-card]');
        const root = event.target.closest?.(SELECTOR);
        if (card && root && typeof root.pbLipRoutineShow === 'function') {
          root.pbLipRoutineShow(card);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-liquids-2plus1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-liquids21')) {
    class PBLiquids21 extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.steps = [...this.querySelectorAll('[data-liquids21-step]')];
        this.selections = new Map();
        this.submitButton = this.querySelector('[data-liquids21-submit]');
        this.submitLabel = this.querySelector('[data-liquids21-submit-label]');
        this.defaultSubmitLabel = this.submitLabel?.textContent || '';
        this.statusElement = this.querySelector('[data-liquids21-status]');

        for (const option of this.querySelectorAll('[data-liquids21-option]')) {
          option.addEventListener('click', () => this.selectOption(option));
        }

        for (const step of this.steps) {
          const position = Number(step.dataset.defaultPosition || 0);
          if (position <= 0) continue;

          const preset = step.querySelector(`[data-liquids21-option][data-position="${position}"]`);
          if (preset && !preset.disabled) this.selectOption(preset, { render: false });
        }

        this.submitButton?.addEventListener('click', () => this.addToCart());
        this.render();
        this.initGallery();
      }

      disconnectedCallback() {
        this.gallery?.destroy?.(true, true);
        this.gallery = null;
      }

      async waitForSwiper(timeout = 8000) {
        const started = Date.now();

        while (typeof window.Swiper === 'undefined') {
          if (Date.now() - started > timeout) throw new Error('Swiper is unavailable');
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        return window.Swiper;
      }

      /** Foto's achter de hoofdfoto. Eén slide: geen carousel, gewoon de foto. */
      async initGallery() {
        const galleryElement = this.querySelector('[data-liquids21-gallery]');
        if (!galleryElement) return;
        if (galleryElement.querySelectorAll('.swiper-slide').length < 2) return;

        try {
          const Swiper = await this.waitForSwiper();
          this.gallery = new Swiper(galleryElement, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            navigation: {
              prevEl: this.querySelector('[data-liquids21-prev]'),
              nextEl: this.querySelector('[data-liquids21-next]'),
            },
            pagination: {
              el: this.querySelector('[data-liquids21-dots]'),
              clickable: true,
            },
          });
        } catch (error) {
          console.error('[PBLiquids21] Gallery init failed', error);
        }
      }

      formatMoney(cents) {
        const currency = this.dataset.currency || 'EUR';
        const amount = (Number(cents) || 0) / 100;

        try {
          // De spatie tussen teken en bedrag eruit — ook de harde spatie die
          // Intl gebruikt — zodat de prijzen staan zoals in het ontwerp: €17,95.
          return new Intl.NumberFormat('nl-NL', { style: 'currency', currency }).format(amount).replace(/\s/g, '');
        } catch (error) {
          return `€${amount.toFixed(2).replace('.', ',')}`;
        }
      }

      selectOption(option, options = {}) {
        if (option.disabled || option.dataset.available === 'false') return;

        const step = option.closest('[data-liquids21-step]');
        const stepId = option.dataset.stepId;
        if (!step || !stepId) return;

        for (const sibling of step.querySelectorAll('[data-liquids21-option]')) {
          sibling.setAttribute('aria-pressed', sibling === option ? 'true' : 'false');
        }

        this.selections.set(stepId, option);

        if (options.render !== false) this.render();
      }

      /**
       * Wat de klant betaalt zodra alle stappen gekozen zijn. De gratis flessen
       * zijn de goedkoopste van de selectie — zo rekent de automatische korting
       * in Shopify ook, en bij gelijke flesprijzen komt dat op hetzelfde neer
       * als "de fles uit de gratis stap".
       */
      totals() {
        const selected = [...this.selections.values()];
        const complete = this.steps.length > 0 && selected.length === this.steps.length;
        const prices = selected.map((option) => Number(option.dataset.price) || 0);
        const originalTotal = prices.reduce((sum, price) => sum + price, 0);

        if (!complete) {
          return { complete, originalTotal, total: originalTotal, saving: 0 };
        }

        const freeCount = Math.min(Number(this.dataset.freeCount) || 0, prices.length);
        const saving = [...prices]
          .sort((a, b) => a - b)
          .slice(0, freeCount)
          .reduce((sum, price) => sum + price, 0);

        return { complete, originalTotal, total: originalTotal - saving, saving };
      }

      render() {
        const { complete, originalTotal, total, saving } = this.totals();
        const compareElement = this.querySelector('[data-liquids21-compare]');
        const totalElement = this.querySelector('[data-liquids21-total]');
        const savingElement = this.querySelector('[data-liquids21-saving]');
        const washesElement = this.querySelector('[data-liquids21-washes]');
        const hasMissingVariant = [...this.selections.values()].some((option) => !option.dataset.variantId);

        if (totalElement) totalElement.textContent = this.formatMoney(total);

        if (compareElement) {
          compareElement.hidden = saving <= 0;
          compareElement.textContent = this.formatMoney(originalTotal);
        }

        if (savingElement) {
          savingElement.hidden = saving <= 0;
          savingElement.textContent = `${this.dataset.savingLabel || 'Je bespaart'} ${this.formatMoney(saving)}`;
        }

        // "99 wasbeurten · €0,24 per wasbeurt": wasbeurten per fles keer het
        // aantal flessen, gedeeld op wat de klant betaalt.
        if (washesElement) {
          const perBottle = Number(this.dataset.washesPerBottle) || 0;
          const washes = perBottle * this.steps.length;
          const show = complete && washes > 0 && total > 0;
          washesElement.hidden = !show;
          if (show) {
            const perWash = Math.round(total / washes);
            washesElement.textContent = `${washes} ${this.dataset.washesLabel || 'wasbeurten'} · ${this.formatMoney(perWash)} ${this.dataset.perWashLabel || 'per wasbeurt'}`;
          }
        }

        if (this.submitButton) {
          this.submitButton.disabled = !complete || hasMissingVariant;
        }
      }

      /** Dezelfde fles twee keer wordt één regel met aantal 2. */
      cartItems() {
        const quantityByVariant = new Map();

        for (const option of this.selections.values()) {
          const variantId = option.dataset.variantId;
          if (!variantId) continue;

          quantityByVariant.set(variantId, (quantityByVariant.get(variantId) || 0) + 1);
        }

        return [...quantityByVariant].map(([id, quantity]) => ({ id, quantity }));
      }

      async waitForCart(timeout = 8000) {
        const started = Date.now();

        while (!window.PBCart?.addLines) {
          if (Date.now() - started > timeout) throw new Error('Cart integration is unavailable');
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        return window.PBCart;
      }

      async addToCart() {
        if (!this.submitButton || this.submitButton.disabled) return;

        const items = this.cartItems();
        if (!items.length) return;

        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        if (this.submitLabel && this.dataset.addingLabel) {
          this.submitLabel.textContent = this.dataset.addingLabel;
        }
        if (this.statusElement) this.statusElement.textContent = '';

        try {
          // Geen bevestiging: de cart drawer gaat open, dat is de bevestiging.
          // De statusregel is er alleen nog voor als het misgaat.
          const cart = await this.waitForCart();
          await cart.addLines(items);
        } catch (error) {
          console.error('[PBLiquids21] Add to cart failed', error);
          if (this.statusElement) this.statusElement.textContent = this.dataset.errorLabel || '';
        } finally {
          this.submitButton.removeAttribute('aria-busy');
          if (this.submitLabel) this.submitLabel.textContent = this.defaultSubmitLabel;
          this.render();
        }
      }
    }

    customElements.define('pb-liquids21', PBLiquids21);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-liquids-compare"] && !Shopify.designMode) return;
  try {
    
  // Scroll-CTA: naar het element met het id uit de href, met de
  // scroll-margin-top van het doel erbij zodat de titel niet onder de sticky
  // nav valt. Zelfde aanpak als de scroll-links in dvhh.js.
  function initLiquidsCompareScroll(root) {
    root.querySelectorAll('[data-cmp-scroll]').forEach((link) => {
      if (link.dataset.cmpScrollReady === 'true') return;
      link.dataset.cmpScrollReady = 'true';

      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;

        let target = null;
        try {
          target = document.getElementById(decodeURIComponent(href.slice(1)));
        } catch (error) {
          target = null;
        }
        if (!target) return;

        event.preventDefault();

        const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  initLiquidsCompareScroll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initLiquidsCompareScroll(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-liquids-forms"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-liquids-forms')) {
    class PBLiquidsForms extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.tabs = [...this.querySelectorAll('[data-forms-tab]')];
        this.panels = [...this.querySelectorAll('[data-forms-panel]')];
        this.activeForm = this.dataset.active || this.tabs[0]?.dataset.form || '';

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab.dataset.form));
          tab.addEventListener('keydown', (event) => {
            // Pijltjes wisselen van tab, zoals bij een gewone tablist.
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const step = event.key === 'ArrowRight' ? 1 : -1;
            const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
            if (next) {
              this.select(next.dataset.form);
              next.focus();
            }
          });
        });

        this.initScrollLinks();
        this.render();
      }

      select(form) {
        this.activeForm = form;
        this.render();
      }

      render() {
        this.dataset.active = this.activeForm;

        for (const tab of this.tabs) {
          const active = tab.dataset.form === this.activeForm;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        }

        for (const panel of this.panels) {
          panel.hidden = panel.dataset.form !== this.activeForm;
        }
      }

      // Scroll-CTA: naar het element met het id uit de href, met de
      // scroll-margin-top van het doel erbij zodat de titel niet onder de
      // sticky nav valt. Zelfde aanpak als de scroll-links in dvhh.js.
      initScrollLinks() {
        for (const link of this.querySelectorAll('[data-forms-scroll]')) {
          link.addEventListener('click', (event) => {
            const href = link.getAttribute('href') || '';
            if (href.charAt(0) !== '#' || href.length < 2) return;

            let target = null;
            try {
              target = document.getElementById(decodeURIComponent(href.slice(1)));
            } catch (error) {
              target = null;
            }
            if (!target) return;

            event.preventDefault();

            const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        }
      }
    }

    customElements.define('pb-liquids-forms', PBLiquidsForms);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-liquids-hero"] && !Shopify.designMode) return;
  try {
    
  // Scroll-CTA: naar het element met het id uit de href scrollen, met de
  // scroll-margin-top van het doel erbij, zodat de titel niet onder de sticky
  // nav valt. Zelfde aanpak als de scroll-links in dvhh.js, maar zonder die
  // afhankelijkheid, zodat deze hero ook werkt op pagina's zonder DVHH-secties.
  function initLiquidsHeroScroll(root) {
    root.querySelectorAll('[data-liquids-hero-scroll]').forEach((link) => {
      if (link.dataset.liquidsHeroScrollReady === 'true') return;
      link.dataset.liquidsHeroScrollReady = 'true';

      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;

        let target = null;
        try {
          target = document.getElementById(decodeURIComponent(href.slice(1)));
        } catch (error) {
          target = null;
        }
        if (!target) return;

        event.preventDefault();

        const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  initLiquidsHeroScroll(document);

  // In de theme editor wordt de sectie opnieuw gerenderd; de links dan weer
  // aanhaken. Buiten de editor komt dit event niet voor.
  document.addEventListener('shopify:section:load', (event) => {
    initLiquidsHeroScroll(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-liquids-in-use"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-liquids-in-use')) {
    class PBLiquidsInUse extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-use-track]');
        this.cards = [...this.querySelectorAll('[data-use-card]')];
        this.dots = [...this.querySelectorAll('[data-use-dot]')];
        this.activeIndex = 0;

        for (const dot of this.dots) {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index) || 0));
        }

        if (this.track) {
          this.track.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
        }

        this.initScrollLinks();
      }

      // Welke kaart staat het dichtst bij de linkerrand van de track?
      syncFromScroll() {
        if (!this.track || this.cards.length === 0) return;

        const left = this.track.scrollLeft;
        let closest = 0;
        let distance = Infinity;

        this.cards.forEach((card, index) => {
          const d = Math.abs(card.offsetLeft - this.track.offsetLeft - left);
          if (d < distance) {
            distance = d;
            closest = index;
          }
        });

        this.setActive(closest);
      }

      goTo(index) {
        const card = this.cards[index];
        if (!card || !this.track) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({
          left: card.offsetLeft - this.track.offsetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
        this.setActive(index);
      }

      setActive(index) {
        if (index === this.activeIndex && this.dots[index]?.getAttribute('aria-pressed') === 'true') return;
        this.activeIndex = index;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
      }

      // Scroll-CTA: naar het element met het id uit de href, met de
      // scroll-margin-top van het doel erbij zodat de titel niet onder de
      // sticky nav valt. Zelfde aanpak als de scroll-links in dvhh.js.
      initScrollLinks() {
        for (const link of this.querySelectorAll('[data-use-scroll]')) {
          link.addEventListener('click', (event) => {
            const href = link.getAttribute('href') || '';
            if (href.charAt(0) !== '#' || href.length < 2) return;

            let target = null;
            try {
              target = document.getElementById(decodeURIComponent(href.slice(1)));
            } catch (error) {
              target = null;
            }
            if (!target) return;

            event.preventDefault();

            const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        }
      }
    }

    customElements.define('pb-liquids-in-use', PBLiquidsInUse);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-liquids-innovation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-liquids-innovation')) {
    class PBLiquidsInnovation extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.hotspots = [...this.querySelectorAll('[data-innov-hotspot]')];
        this.swatches = [...this.querySelectorAll('[data-innov-swatch]')];
        this.bottles = [...this.querySelectorAll('[data-innov-bottle]')];
        this.videos = [...this.querySelectorAll('[data-innov-video]')];
        this.explains = [...this.querySelectorAll('[data-innov-explain]')];
        this.coating = this.querySelector('[data-innov-coating]');
        this.variantLabel = this.querySelector('[data-innov-variant-label]');

        // Niet this.part: Element.part is een ingebouwde DOMTokenList.
        this.activePart = this.dataset.part || this.hotspots[0]?.dataset.part || '';
        this.activeVariant = this.dataset.variant || this.swatches[0]?.dataset.variant || '';
        this.renderReady = false;

        for (const hotspot of this.hotspots) {
          hotspot.addEventListener('click', () => this.pickPart(hotspot.dataset.part));
        }

        for (const swatch of this.swatches) {
          swatch.addEventListener('click', () => this.pickVariant(swatch.dataset.variant));
        }

        for (const video of this.videos) {
          video.muted = true;
          video.defaultMuted = true;
          video.volume = 0;
        }

        this.initScrollLinks();
        this.render();
      }

      get activeHotspot() {
        return this.hotspots.find((hotspot) => hotspot.dataset.part === this.activePart) || null;
      }

      get showsCoating() {
        return this.activeHotspot?.dataset.media === 'coating';
      }

      get activeVideo() {
        return this.videos.find((video) => video.dataset.variant === this.activeVariant) || null;
      }

      pickPart(part) {
        this.activePart = part;
        this.renderReady = false;
        this.render();
        if (this.showsCoating) this.playRender();
      }

      pickVariant(variant) {
        this.activeVariant = variant;
        this.renderReady = false;
        this.render();
        if (this.showsCoating) this.playRender();
      }

      // Speelt de video van de fles die gevormd wordt. De foto van de fles
      // verdwijnt pas zodra de video echt beeld geeft, anders knippert het.
      playRender() {
        const video = this.activeVideo;
        if (!video) return;

        try {
          video.muted = true;
          video.volume = 0;
          video.currentTime = 0;
          const playing = video.play();
          if (playing && typeof playing.catch === 'function') playing.catch(() => {});
        } catch (error) {
          // Autoplay geweigerd: de foto blijft staan.
        }

        const markReady = () => {
          video.removeEventListener('playing', markReady);
          video.removeEventListener('canplay', markReady);
          if (this.activeVideo !== video || !this.showsCoating) return;
          this.renderReady = true;
          this.render();
        };

        if (video.readyState >= 3) {
          markReady();
          return;
        }

        video.addEventListener('playing', markReady);
        video.addEventListener('canplay', markReady);
      }

      render() {
        this.dataset.part = this.activePart;
        this.dataset.variant = this.activeVariant;

        const showsCoating = this.showsCoating;
        const activeVideo = showsCoating ? this.activeVideo : null;
        const showsStill = showsCoating && !activeVideo && Boolean(this.coating);
        // De fles verdwijnt zodra de coating te zien is: meteen bij de
        // coating-afbeelding, bij de video pas zodra die echt beeld geeft.
        const hideBottle = showsStill || (Boolean(activeVideo) && this.renderReady);

        for (const hotspot of this.hotspots) {
          hotspot.setAttribute('aria-pressed', hotspot.dataset.part === this.activePart ? 'true' : 'false');
        }

        for (const explain of this.explains) {
          explain.hidden = explain.dataset.part !== this.activePart;
        }

        for (const swatch of this.swatches) {
          const active = swatch.dataset.variant === this.activeVariant;
          swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (active && this.variantLabel) this.variantLabel.textContent = swatch.dataset.label || '';
        }

        for (const bottle of this.bottles) {
          bottle.classList.toggle('is-off', bottle.dataset.variant !== this.activeVariant || hideBottle);
        }

        for (const video of this.videos) {
          const active = video === activeVideo;
          video.hidden = !active;
          if (!active && !video.paused) video.pause();
        }

        if (this.coating) this.coating.classList.toggle('is-off', !showsStill);
      }

      // Scroll-CTA: naar het element met het id uit de href, met de
      // scroll-margin-top van het doel erbij zodat de titel niet onder de
      // sticky nav valt. Zelfde aanpak als de scroll-links in dvhh.js.
      initScrollLinks() {
        for (const link of this.querySelectorAll('[data-innov-scroll]')) {
          link.addEventListener('click', (event) => {
            const href = link.getAttribute('href') || '';
            if (href.charAt(0) !== '#' || href.length < 2) return;

            let target = null;
            try {
              target = document.getElementById(decodeURIComponent(href.slice(1)));
            } catch (error) {
              target = null;
            }
            if (!target) return;

            event.preventDefault();

            const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        }
      }
    }

    customElements.define('pb-liquids-innovation', PBLiquidsInnovation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-marathon-bundle"] && !Shopify.designMode) return;
  try {
    
  // Het aantal kilometer van een marathon, en de bundelkorting. Moet gelijk zijn
  // aan MARATHON_DISCOUNT in de kortingsapp (planet-b-online-discount) — wijkt
  // dit af, dan belooft de pagina iets anders dan de checkout rekent.
  const PB_MARATHON_DISCOUNT = 42.195;

  if (!customElements.get('pb-marathon-bundle')) {
    class PBMarathonBundle extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.rows = [...this.querySelectorAll('[data-marathon-row]')];
        this.gifts = [...this.querySelectorAll('[data-marathon-gift]')];
        this.selections = new Map();
        this.bundleId = `marathon_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        this.submitButton = this.querySelector('[data-marathon-submit]');
        this.submitLabel = this.querySelector('[data-marathon-submit-label]');
        this.defaultSubmitLabel = this.submitLabel?.textContent || 'Bestel je marathonpakket';
        this.swiperEl = this.querySelector('[data-marathon-swiper]');
        this.prevButton = this.querySelector('[data-marathon-prev]');
        this.nextButton = this.querySelector('[data-marathon-next]');
        this.swiper = null;

        for (const choice of this.querySelectorAll('[data-marathon-choice]')) {
          choice.addEventListener('click', () => this.selectChoice(choice));
        }

        for (const row of this.rows) {
          const defaultFormat = row.dataset.defaultFormat;
          const defaultChoice = row.querySelector(`[data-marathon-choice][data-option="${defaultFormat}"]`);

          if (defaultChoice && !defaultChoice.disabled) {
            this.selectChoice(defaultChoice, { syncCarousel: false });
          }
        }

        this.submitButton?.addEventListener('click', () => this.addToCart());
        this.prepareCarousel();
        this.render();
      }

      disconnectedCallback() {
        this.swiper?.destroy?.(true, true);
        this.swiper = null;
      }

      async waitForSwiper(timeout = 8000) {
        const started = Date.now();

        while (typeof window.Swiper === 'undefined') {
          if (Date.now() - started > timeout) {
            throw new Error('Swiper is unavailable');
          }
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        return window.Swiper;
      }

      getStorefrontConfig() {
        const cfg = window.PB_UNIFIED_CART || window.Shopify?.storefront || {};

        return {
          endpoint: cfg.endpoint || cfg.storefrontApiUrl,
          token: cfg.token || cfg.storefrontAccessToken,
        };
      }

      variantGid(id) {
        const value = String(id || '');
        return value.startsWith('gid://') ? value : `gid://shopify/ProductVariant/${value.replace(/\D/g, '')}`;
      }

      variantNumericId(id) {
        return String(id || '').replace(/\D/g, '');
      }

      escapeHtml(value) {
        return String(value || '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#39;');
      }

      async fetchVariantMedia(ids) {
        const cfg = this.getStorefrontConfig();
        if (!cfg.endpoint || !cfg.token || !ids.length) return new Map();

        const response = await fetch(cfg.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': cfg.token,
          },
          body: JSON.stringify({
            query: `
              query MarathonVariantMedia($ids: [ID!]!) {
                nodes(ids: $ids) {
                  ... on ProductVariant {
                    id
                    title
                    availableForSale
                    image {
                      url(transform: { maxWidth: 1200 })
                      altText
                    }
                    price {
                      amount
                    }
                    compareAtPrice {
                      amount
                    }
                    product {
                      title
                      featuredImage {
                        url(transform: { maxWidth: 1200 })
                        altText
                      }
                    }
                  }
                }
              }
            `,
            variables: { ids: ids.map((id) => this.variantGid(id)) },
          }),
        });

        const json = await response.json();
        if (json.errors) throw new Error(JSON.stringify(json.errors));

        const mediaById = new Map();
        for (const node of json.data?.nodes || []) {
          if (!node?.id) continue;

          const numericId = this.variantNumericId(node.id);
          const imageUrl = node.image?.url || node.product?.featuredImage?.url || '';
          const alt = node.image?.altText || node.product?.featuredImage?.altText || node.product?.title || '';
          const amount = Number(node.price?.amount || 0);
          const priceCents = Number.isFinite(amount) ? Math.round(amount * 100) : 0;
          const compareAmount = Number(node.compareAtPrice?.amount || 0);
          const comparePriceCents = Number.isFinite(compareAmount) ? Math.round(compareAmount * 100) : 0;

          mediaById.set(numericId, {
            imageUrl,
            alt,
            title: node.product?.title || node.title || '',
            priceCents,
            comparePriceCents,
            available: node.availableForSale !== false,
          });
        }

        return mediaById;
      }

      buildSlidesFromChoices(mediaById) {
        const track = this.swiperEl?.querySelector('[data-marathon-track]');
        if (!track) return 0;

        const choices = [...this.querySelectorAll('[data-marathon-choice]')];
        const seen = new Set();
        const slides = [];
        const mainAlt = this.swiperEl.dataset.mainAlt || '';
        const placeholder = this.swiperEl.dataset.mainPlaceholder || '';

        // Zonder hoofdafbeelding maar mét combinatiefoto's is er nog steeds een
        // hoofdslide nodig — syncComboImage vult die daarna met de juiste foto.
        const mainImage =
          this.swiperEl.dataset.mainImage ||
          Object.values(this.comboImages())[0] ||
          '';

        if (mainImage) {
          slides.push(`
            <div class="swiper-slide" data-marathon-slide data-marathon-main-slide>
              <img
                class="pb-marathon__hero-image"
                src="${this.escapeHtml(mainImage)}"
                alt="${this.escapeHtml(mainAlt)}"
                width="1200"
                height="1200"
                loading="eager"
                data-marathon-slide-image
              >
            </div>
          `);
        }

        for (const extra of this.carouselImages()) {
          if (!extra?.url) continue;

          slides.push(`
            <div class="swiper-slide" data-marathon-slide data-marathon-carousel-slide>
              <img
                class="pb-marathon__hero-image"
                src="${this.escapeHtml(extra.url)}"
                alt="${this.escapeHtml(extra.alt || mainAlt)}"
                width="1200"
                height="1200"
                loading="lazy"
                data-marathon-slide-image
              >
            </div>
          `);
        }

        for (const choice of choices) {
          const id = this.variantNumericId(choice.dataset.variantId);
          if (!id || seen.has(id)) continue;
          seen.add(id);

          const media = mediaById.get(id);
          const imageUrl = media?.imageUrl || choice.dataset.image || '';
          const alt = media?.alt || choice.dataset.title || '';

          if (media?.imageUrl) choice.dataset.image = media.imageUrl;
          if (media?.title) choice.dataset.title = media.title;
          if (media?.priceCents > 0) {
            choice.dataset.price = String(media.priceCents);
          }
          if (media?.comparePriceCents > 0) {
            choice.dataset.comparePrice = String(media.comparePriceCents);
          }
          // Na het bijwerken van beide, zodat de doorstreepprijs meeloopt met de
          // live variantprijs. Anders blijft de prijs uit Liquid staan zodra een
          // van de twee in Shopify verandert.
          if (media?.priceCents > 0) {
            this.renderChoicePrice(choice);
          }
          if (media) {
            choice.dataset.available = media.available ? 'true' : 'false';
            choice.toggleAttribute('disabled', !media.available);
            choice.removeAttribute('data-needs-image');
          }

          if (!this.showVariantImages() || !imageUrl) continue;

          slides.push(`
            <div class="swiper-slide" data-marathon-slide data-variant-id="${this.escapeHtml(id)}">
              <img
                class="pb-marathon__hero-image"
                src="${this.escapeHtml(imageUrl)}"
                alt="${this.escapeHtml(alt)}"
                width="1200"
                height="1200"
                loading="lazy"
                data-marathon-slide-image
              >
            </div>
          `);
        }

        if (!slides.length) {
          slides.push(`
            <div class="swiper-slide" data-marathon-slide data-marathon-main-slide>
              <div class="pb-marathon__hero-placeholder">${this.escapeHtml(placeholder)}</div>
            </div>
          `);
        }

        track.innerHTML = slides.join('');
        return track.querySelectorAll('.swiper-slide').length;
      }

      async hydrateAndBuildSlides() {
        const choices = [...this.querySelectorAll('[data-marathon-choice]')];
        const ids = [
          ...new Set(choices.map((choice) => this.variantNumericId(choice.dataset.variantId)).filter(Boolean)),
        ];

        let mediaById = new Map();
        if (ids.length) {
          try {
            mediaById = await this.fetchVariantMedia(ids);
          } catch (error) {
            console.error('[PBMarathon] Variant media hydration failed', error);
          }
        }

        return this.buildSlidesFromChoices(mediaById);
      }

      async prepareCarousel() {
        await this.hydrateAndBuildSlides();
        this.render();
        await this.initSwiper();

        const activeChoice =
          this.querySelector('[data-marathon-choice][aria-pressed="true"]') ||
          this.querySelector('[data-marathon-choice]:not([disabled])');
        if (activeChoice) this.syncCarouselToChoice(activeChoice);
      }

      async initSwiper() {
        if (!this.swiperEl) return;

        this.swiper?.destroy?.(true, true);
        this.swiper = null;

        const slides = this.swiperEl.querySelectorAll('.swiper-slide');
        if (slides.length < 2) {
          this.prevButton?.setAttribute('hidden', '');
          this.nextButton?.setAttribute('hidden', '');
          return;
        }

        this.prevButton?.removeAttribute('hidden');
        this.nextButton?.removeAttribute('hidden');

        try {
          const Swiper = await this.waitForSwiper();
          this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            navigation: {
              prevEl: this.prevButton,
              nextEl: this.nextButton,
            },
          });
        } catch (error) {
          console.error('[PBMarathon] Swiper init failed', error);
        }
      }

      /** Map van combinatiesleutel naar afbeelding, uit de sectie-instellingen. */
      comboImages() {
        if (this.comboImageMap) return this.comboImageMap;

        try {
          this.comboImageMap = JSON.parse(this.swiperEl?.dataset.comboImages || '{}');
        } catch (error) {
          console.error('[PBMarathon] combo images parse failed', error);
          this.comboImageMap = {};
        }

        return this.comboImageMap;
      }

      /** Extra customizer carousel images (after main, before variants). Empty slots are omitted in Liquid. */
      carouselImages() {
        if (this.carouselImageList) return this.carouselImageList;

        try {
          const parsed = JSON.parse(this.swiperEl?.dataset.carouselImages || '[]');
          this.carouselImageList = Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.error('[PBMarathon] carousel images parse failed', error);
          this.carouselImageList = [];
        }

        return this.carouselImageList;
      }

      showVariantImages() {
        return this.swiperEl?.dataset.showVariantImages !== 'false';
      }

      /**
       * Eén letter per wasrij in DOM-volgorde: s = wasstrips, l = liquid. Leeg
       * zolang niet elke rij een keuze heeft, want dan is er geen combinatie.
       */
      comboKey() {
        const rows = [...this.querySelectorAll('[data-marathon-row]')];
        if (!rows.length) return '';

        let key = '';

        for (const row of rows) {
          const chosen = row.querySelector('[data-marathon-choice][aria-pressed="true"]');
          if (!chosen) return '';

          const option = String(chosen.dataset.option || '').toLowerCase();
          if (option === 'strips') {
            key += 's';
          } else if (option === 'liquid') {
            key += 'l';
          } else {
            return '';
          }
        }

        return key;
      }

      comboImageFor(key) {
        return (key && this.comboImages()[key]) || '';
      }

      /**
       * Zet de combinatiefoto op de hoofdslide. Valt terug op de ingestelde
       * hoofdafbeelding zodra de selectie niet meer compleet is.
       */
      syncComboImage() {
        const image = this.swiperEl?.querySelector(
          '[data-marathon-main-slide] [data-marathon-slide-image]'
        );
        if (!image) return;

        const key = this.comboKey();
        const comboUrl = this.comboImageFor(key);
        const next = comboUrl || this.swiperEl.dataset.mainImage || '';

        if (next && image.getAttribute('src') !== next) {
          image.setAttribute('src', next);
          image.removeAttribute('srcset');
        }

        // Alleen springen als de combinatie net veranderd is. Bij elke render
        // springen zou de pijltjes van de carousel onbruikbaar maken.
        if (comboUrl && key !== this.comboKeyShown) {
          this.swiper?.slideTo(0, 300);
        }

        this.comboKeyShown = comboUrl ? key : '';
      }

      syncCarouselToChoice(choice) {
        if (!this.swiper || !choice) return;

        const variantId = this.variantNumericId(choice.dataset.variantId);
        if (!variantId) return;

        const slides = [...this.swiperEl.querySelectorAll('.swiper-slide[data-variant-id]')];
        const index = slides.findIndex((slide) => this.variantNumericId(slide.dataset.variantId) === variantId);
        if (index < 0) return;

        this.swiper.slideTo(index, 300);
      }

      selectChoice(choice, options = {}) {
        if (choice.disabled || choice.dataset.available === 'false') return;

        const rowId = choice.dataset.rowId;
        const row = choice.closest('[data-marathon-row]');
        if (!rowId || !row) return;

        for (const sibling of row.querySelectorAll('[data-marathon-choice]')) {
          sibling.setAttribute('aria-pressed', sibling === choice ? 'true' : 'false');
        }

        this.selections.set(rowId, choice);

        // Is de combinatie compleet én is er een foto voor, dan neemt die de
        // hoofdslide over — dan niet ook nog naar de losse variantslide springen.
        const hasComboImage = Boolean(this.comboImageFor(this.comboKey()));

        if (options.syncCarousel !== false && !hasComboImage) {
          this.syncCarouselToChoice(choice);
        }

        this.render();
      }

      formatMoney(cents) {
        const currency = this.dataset.currency || 'EUR';

        try {
          return new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency,
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `€${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')}`;
        }
      }

      /** Doorstreepprijs van een keuze, of gewoon de prijs als die er niet is. */
      comparePriceFor(item) {
        const price = Number(item.dataset.price || 0);
        const compare = Number(item.dataset.comparePrice || 0);
        return compare > price ? compare : price;
      }

      /**
       * Zelfde als de Liquid-markup: de volle prijs, zonder de introkorting die
       * er al vanaf is. Die korting zit verwerkt in het bundeltotaal, niet in
       * het bedrag op de knop.
       */
      renderChoicePrice(choice) {
        const priceEl = choice.querySelector('[data-marathon-choice-price]');
        if (!priceEl) return;

        priceEl.textContent = this.formatMoney(this.comparePriceFor(choice));
      }

      render() {
        const complete = this.rows.length > 0 && this.selections.size === this.rows.length;
        const selectedItems = [...this.selections.values()];
        const allItems = [...selectedItems, ...(complete ? this.gifts : [])];

        // Alles rekent op de volle prijs: de doorstreepprijs waar die bestaat, en
        // anders de gewone prijs — zoals bij de boosters. De introkorting die al
        // in de productprijs zit telt dus niet mee; die twee kortingen stapelen
        // niet.
        //
        // De kortingsfunctie in de app doet dezelfde berekening en trekt een
        // vast bedrag af om op ditzelfde eindbedrag uit te komen. Wijzig je hier
        // iets, wijzig het daar mee, anders lopen pagina en checkout uiteen.
        //
        // De boosters staan hieronder als "gratis", maar dat is een label. Ze
        // zitten gewoon in de som.
        const originalTotal = allItems.reduce((sum, item) => {
          return sum + this.comparePriceFor(item);
        }, 0);

        // Shopify kapt de korting af op hele centen, en doet dat één keer op de
        // samengevoegde bundelregel. Zelfde berekening hier.
        const discountAmount = complete
          ? Math.floor((originalTotal * PB_MARATHON_DISCOUNT) / 100)
          : 0;
        const bundleTotal = originalTotal - discountAmount;
        const savingAmount = Math.max(0, discountAmount);
        const originalElement = this.querySelector('[data-marathon-original]');
        const totalElement = this.querySelector('[data-marathon-total]');
        const savingElement = this.querySelector('[data-marathon-saving]');
        const giftsElement = this.querySelector('[data-marathon-gifts]');
        const hasUnavailableGift = this.gifts.some((gift) => gift.dataset.available === 'false');
        const hasMissingVariant = [...selectedItems, ...this.gifts].some((item) => !item.dataset.variantId);

        if (totalElement) totalElement.textContent = this.formatMoney(bundleTotal);
        if (giftsElement) giftsElement.hidden = !complete;
        if (originalElement) {
          originalElement.hidden = !complete || savingAmount <= 0;
          originalElement.textContent = this.formatMoney(originalTotal);
        }
        if (savingElement) {
          savingElement.hidden = !complete || savingAmount <= 0;
          // Het percentage klopt hier weer: de besparing is exact 42,195% van
          // het doorstreepte totaal.
          savingElement.textContent = `Je bespaart ${this.formatMoney(savingAmount)} (${String(PB_MARATHON_DISCOUNT).replace('.', ',')}%)`;
        }
        if (this.submitButton) {
          this.submitButton.disabled = !complete || hasUnavailableGift || hasMissingVariant;
        }

        this.syncComboImage();
      }

      itemFromElement(element, gift = false) {
        const properties = {
          _marathon_bundle: 'true',
          _marathon_bundle_id: this.bundleId,
          _marathon_bundle_title: this.dataset.bundleTitle || 'Marathonpakket',
          _marathon_bundle_image: this.dataset.bundleImage || '',
          _marathon_bundle_item_title: element.dataset.title || '',
          _marathon_bundle_format: gift ? 'Gift' : element.dataset.format || '',
          _marathon_bundle_gift: gift ? 'true' : 'false',
        };

        return {
          id: Number(element.dataset.variantId),
          variantId: Number(element.dataset.variantId),
          quantity: 1,
          title: element.dataset.title || '',
          image: element.dataset.image || '',
          price: Number(element.dataset.price || 0),
          properties,
        };
      }

      async waitForCart(timeout = 8000) {
        const started = Date.now();

        while (!window.PBCart?.replaceMarathonBundle) {
          if (Date.now() - started > timeout) {
            throw new Error('Marathon cart integration is unavailable');
          }
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        return window.PBCart;
      }

      async addToCart() {
        if (!this.submitButton || this.submitButton.disabled) return;

        const status = this.querySelector('[data-marathon-status]');
        // Fresh id per add so multiple Marathon bundles can coexist in the cart.
        this.bundleId = `marathon_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        const selectedItems = [...this.selections.values()].map((item) => this.itemFromElement(item));
        const giftItems = this.gifts.map((gift) => this.itemFromElement(gift, true));

        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        if (this.submitLabel) this.submitLabel.textContent = 'Toevoegen…';
        if (status) status.textContent = '';

        try {
          const cart = await this.waitForCart();
          await cart.replaceMarathonBundle({
            bundleId: this.bundleId,
            bundleTitle: this.dataset.bundleTitle || 'Marathonpakket',
            bundleImage: this.dataset.bundleImage || '',
            replaceExisting: false,
            cartItems: [...selectedItems, ...giftItems],
          });
          if (status) status.textContent = 'Je marathonpakket is toegevoegd.';
        } catch (error) {
          console.error('[PBMarathon] Add to cart failed', error);
          if (status) status.textContent = 'Toevoegen is niet gelukt. Probeer het opnieuw.';
        } finally {
          this.submitButton.removeAttribute('aria-busy');
          if (this.submitLabel) this.submitLabel.textContent = this.defaultSubmitLabel;
          this.render();
        }
      }
    }

    customElements.define('pb-marathon-bundle', PBMarathonBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["planetb-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
